import PropTypes from 'prop-types'
import React from 'react'
import ExpandMore from '@mui/icons-material/ExpandMore'
import MuiAccordion from '@mui/material/Accordion'
import MuiAccordionSummary from '@mui/material/AccordionSummary'
import MuiAccordionDetails from '@mui/material/AccordionDetails'

const Accordion = ({ title, children }) => {
  return (
    <MuiAccordion defaultExpanded={true} classes={{ root: 'bg-transparent shadow-none' }}>
      <MuiAccordionSummary
        expandIcon={<ExpandMore className="text-blue-700 mx-3 md:hidden" />}
        className="bg-transparent p-0 mt-8 mb-4 overflow-hidden"
        sx={{ minHeight: '0!important', '& .MuiAccordionSummary-content': { margin: '0!important' } }}
        classes={{ expandIcon: 'p-0' }}
      >
        {title}
      </MuiAccordionSummary>
      <MuiAccordionDetails classes={{ root: 'p-0' }}>{children}</MuiAccordionDetails>
    </MuiAccordion>
  )
}

export default Accordion

Accordion.propTypes = {
  children: PropTypes.node,
  title: PropTypes.element
}
